import { put, call } from 'redux-saga/effects'
import {
  setAuthHeader,
  handleError,
  authApiService,
  operatorUserApiService,
  handleSuccess,
} from 'Services/ApiService.js'
import AuthActions from 'Stores/Auth/Actions'
import RootActions from 'Stores/RootActions'
import { updateCurrency } from 'Constants/Filters'
import i18n from 'i18next'

export function* operatorUserLogin({ email, password }) {
  yield put(AuthActions.operatorUserLoginLoading())

  try {
    const response = yield call(authApiService.post, '/operatorUser', {
      email: email,
      password: password,
    })

    yield put(AuthActions.operatorUserLoginSuccess(response.data))
  } catch (e) {
    yield put(AuthActions.operatorUserLoginFail())
    handleError(e)
  }
}

export function* onTwoFactorVerify({ token, challengeId }) {
  yield put(AuthActions.operatorUserLoginLoading())

  try {
    const response = yield call(
      authApiService.post,
      '/operatorUser/login/verify-2fa',
      {
        token: token,
        challengeId: challengeId,
      },
    )

    setAuthHeader(
      response.headers['x-operator-auth-token'],
      response.headers['x-operator-refresh-token'],
    )
    yield put(
      AuthActions.onTwoFactorVerifySuccess(
        response.headers['x-operator-auth-token'],
        response.headers['x-operator-refresh-token'],
        response.data,
      ),
    )
    updateCurrency(response.data.currencyCode)
  } catch (e) {
    yield put(AuthActions.onTwoFactorVerifyFail())
    handleError(e)
  }
}

export function* onTwoFactorSetupVerify({ token, challengeId }) {
  yield put(AuthActions.operatorUserLoginLoading())

  try {
    yield call(authApiService.post, '/operatorUser/2fa/verify-setup', {
      token: token,
      challengeId: challengeId,
    })

    yield put(AuthActions.onTwoFactorSetupVerifySuccess())
    handleSuccess(i18n.t('Login.TwoFactorSetupComplete'))
  } catch (e) {
    yield put(AuthActions.onTwoFactorSetupVerifyFail())
    handleError(e)
  }
}

export function* fetchOperatorUser() {
  try {
    yield put(AuthActions.fetchOperatorUserLoading())
    const { data } = yield call(operatorUserApiService.get, '/me')
    yield put(AuthActions.fetchOperatorUserSuccess(data))
  } catch (e) {
    yield put(AuthActions.fetchOperatorUserFail())
    handleError(e)
  }
}

export function* operatorUserLogout() {
  try {
    yield call(authApiService.post, '/operatorUser/logout')
    yield put(RootActions.resetAllStores())
  } catch (e) {
    handleError(e)
  }
}

export function* resetPassVerification({ email, onSuccess }) {
  yield put(AuthActions.resetPassVerificationLoading())

  try {
    const { data } = yield call(
      operatorUserApiService.post,
      '/resetPasswordEmailVerification',
      {
        email: email,
      },
    )

    yield put(AuthActions.resetPassVerificationSuccess(data.id))
    onSuccess()
  } catch (e) {
    yield put(AuthActions.resetPassVerificationFail())
    handleError(e)
  }
}

export function* resetPass({
  newPassword,
  emailVerificationCode,
  emailVerificationId,
  onSuccess,
}) {
  yield put(AuthActions.resetPassLoading())

  try {
    yield call(operatorUserApiService.post, '/resetPassword', {
      emailVerificationId: emailVerificationId,
      emailVerificationCode: emailVerificationCode,
      newPassword: newPassword,
    })

    yield put(AuthActions.resetPassSuccess())
    onSuccess()
  } catch (e) {
    yield put(AuthActions.resetPassFail(e))
    handleError(e)
  }
}
